import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
export function ToggleRow({ label, checked, onChange, disabled, labelAdornment, ariaLabel, size = 'default' }) {
    const toggle = (_jsx("button", { type: "button", role: "switch", "aria-checked": checked, "aria-label": ariaLabel ?? label, disabled: disabled, onClick: () => onChange(!checked), className: `
                relative inline-flex flex-shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out
                ${size === 'sm' ? 'h-5 w-9' : 'h-6 w-11'}
                ${checked ? 'bg-primary-600' : 'bg-slate-200 dark:bg-slate-600'}
                ${disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'}
            `, children: _jsx("span", { className: `
                    pointer-events-none inline-block rounded-full bg-white shadow ring-0 transition-transform duration-200 ease-in-out
                    ${size === 'sm' ? 'h-4 w-4' : 'h-5 w-5'}
                    ${size === 'sm'
                ? (checked ? 'translate-x-4' : 'translate-x-0')
                : (checked ? 'translate-x-5' : 'translate-x-0')}
                ` }) }));
    if (!label)
        return toggle;
    return (_jsxs("label", { className: `flex items-center justify-between py-2 ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`, children: [_jsxs("span", { className: "flex items-baseline gap-2", children: [_jsx("span", { className: "text-sm font-medium text-slate-700 dark:text-slate-300", children: label }), labelAdornment] }), toggle] }));
}
